// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .backgroundImage--gTd2_ {
  background-image: url('/dist/src/img/backgrounds/grey_background.png');
  background-size: cover;
  padding-bottom: 70px;
}

.backgroundWhite--co2K_ {
  position: relative;
}

[dir] .backgroundWhite--co2K_ {
  background-color: white;
  padding: 25px;
  margin-top: 15px;
  border-radius: 14px;
}

.infoIcon--SdiXD {
  position: absolute;
  top: 15px;

  color: #a4a4a4;
  transition: color 0.6s ease;

  &:hover {
    color: #e6512d;
  }
}

[dir] .infoIcon--SdiXD {
  cursor: pointer
}

[dir=ltr] .infoIcon--SdiXD {
  right: 15px
}

[dir=rtl] .infoIcon--SdiXD {
  left: 15px
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/GroupDetailedInfo/styles.css"],"names":[],"mappings":"AAAA;EACE,sEAAsE;EACtE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EAIE,kBAAkB;AAEpB;;AANA;EACE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAEhB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;;EAGT,cAAc;EACd,2BAA2B;;EAG3B;IACE,cAAc;EAChB;AACF;;AAZA;EAOE;AAKF;;AAZA;EAGE;AASF;;AAZA;EAGE;AASF","sourcesContent":[".backgroundImage {\n  background-image: url('/dist/src/img/backgrounds/grey_background.png');\n  background-size: cover;\n  padding-bottom: 70px;\n}\n\n.backgroundWhite {\n  background-color: white;\n  padding: 25px;\n  margin-top: 15px;\n  position: relative;\n  border-radius: 14px;\n}\n\n.infoIcon {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n\n  color: #a4a4a4;\n  transition: color 0.6s ease;\n  cursor: pointer;\n\n  &:hover {\n    color: #e6512d;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundImage": `backgroundImage--gTd2_`,
	"backgroundWhite": `backgroundWhite--co2K_`,
	"infoIcon": `infoIcon--SdiXD`
};
export default ___CSS_LOADER_EXPORT___;
